import { FighterTile } from './FighterTile';
import { groupByFighter } from '../features/rsvp/lib/characters';
import type { CharacterRow } from '../lib/types';

interface FighterGridProps {
  characters: CharacterRow[];
  selectedName: string | null;
  onPickFighter: (name: string) => void;
}

export function FighterGrid({ characters, selectedName, onPickFighter }: FighterGridProps) {
  // Group characters by name, keeping track of first variant as thumbnail
  const fighterMap = groupByFighter(characters);

  const fighters = Array.from(fighterMap.entries())
    .map(([name, variants]) => {
      // Sort variants by variant label so "Palette 1" is always first and
      // serves as the canonical thumbnail. Without this, variants[0] depends
      // on DB insertion order (the API sorts only by sort_order, name).
      const ordered = [...variants].sort((a, b) =>
        (a.variant ?? '').localeCompare(b.variant ?? ''),
      );
      return { name, variants: ordered };
    })
    .sort((a, b) => {
      const aOrder = a.variants[0]?.sort_order ?? 0;
      const bOrder = b.variants[0]?.sort_order ?? 0;
      return aOrder - bOrder;
    });

  return (
    <div className="smash-fighter-grid">
      {fighters.map(({ name, variants }, index) => {
        const allTaken = variants.every((v) => v.taken === 1);
        const thumb = variants[0]!;
        const isSelected = selectedName === name;

        return (
          <FighterTile
            key={name}
            imageUrl={thumb.image_url}
            label={name}
            selected={isSelected}
            disabled={allTaken}
            onClick={() => onPickFighter(name)}
            index={index}
            total={fighters.length}
          />
        );
      })}
    </div>
  );
}
